<template>
  <span @click="markRead">
    <a class="wrap center" :class="{new: !alert.read}" @click="markRead" v-if="!alert.hasOwnProperty('to')">
      <span v-if="alert" >{{alert && alert.content ? alert.content.replace(/<[^>]*>?/gm, '') : alert.message.replace(/<[^>]*>?/gm, '')| truncate}}</span>
    </a>
    <router-link :to="'#'" class="wrap center" @click="markRead" :class="{new: !alert.read}" v-else>
      <span v-if="alert">{{alert && alert.content ? alert.content.replace(/<[^>]*>?/gm, '') : alert.message.replace(/<[^>]*>?/gm, '')| truncate}}</span>
    </router-link>
  </span>
  
</template>

<script>
export default {
  name: 'notification-component',
  props: {
    alert: {
      type: Object,
      default: null,
    },
  },
  methods: {
    markRead() {
      this.$emit('read', this.alert.id);
      console.log('Emitted read event with ' + this.alert.id);
    },
  },
  filters: {
    truncate(string) {
      return string.substring(0, 60) + "...";
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  padding: 5px 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  clear: both;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.42857143;
  color: #818181;
  text-decoration: none;
  white-space: nowrap;
  margin: 5px 0;
  &.wrap {
    white-space: normal;
  }
  &.new {
    background-color: rgba(2, 17, 27, 0.03);
  }
  &.center {
    font-size: 11px;
    justify-content: center;
    text-align: center;
  }
}
a:hover {
  background-image: none;
  filter: none;
  background-color: rgba(2, 17, 27, 0.05);
  color: #818181;
}
a>svg {
  margin-right: 7px;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/Dashboard/partials/Notifications/Notification.vue